// LogoIconForPDF.tsx
import React from 'react';
import { Svg, Path, Circle } from '@react-pdf/renderer';

const LogoIconForPDF = () => (
  <Svg
    viewBox="0 0 100 100"
    width="10mm"
    height="10mm"
  >
    <Path d="M54.996,46.259c1.385,0.694,3.07,0.131,3.763-1.254L62.5,37.5l28.125,56.25h6.25L62.511,25l-8.769,17.496 C53.049,43.881,53.61,45.566,54.996,46.259z" fill="#005a96" />
    <Circle cx="50" cy="12.5" r="9.375" fill="#005a96" />
    <Path d="M41.069,61.824h5.361c1.177,0,1.798,0.721,2.064,1.151c0.266,0.43,0.633,1.308,0.106,2.36L34.393,93.75h12.464 l11.715-23.43c2.119-4.238,1.897-9.176-0.594-13.207s-6.808-6.438-11.547-6.438h-5.361c-1.177,0-1.798-0.721-2.064-1.151 c-0.266-0.43-0.633-1.308-0.106-2.36l6.711-13.422c1.377-2.754,0.261-6.102-2.493-7.478c-2.753-1.377-6.101-0.261-7.478,2.493 L28.928,42.18c-2.119,4.238-1.897,9.176,0.594,13.207S36.33,61.824,41.069,61.824z" fill="#005a96" />
    <Path d="M18.452,63.132L3.143,93.75h12.464l12.816-25.632c1.377-2.754,0.261-6.102-2.493-7.478 C23.177,59.263,19.829,60.379,18.452,63.132z" fill="#005a96" />
    <Path d="M14.371,46.259c0.403,0.202,0.83,0.297,1.252,0.297c1.029,0,2.019-0.568,2.511-1.551l7.812-15.625 c0.693-1.386,0.131-3.07-1.254-3.763c-1.385-0.693-3.07-0.131-3.763,1.254l-7.812,15.625 C12.424,43.881,12.985,45.566,14.371,46.259z" fill="#005a96" />
  </Svg>
);

export default LogoIconForPDF;
